var api='http://13qgmz.artron.net/index'
module.exports = api;